/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import LayoutAPI from '@/api/LayoutAPI.js';

import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';
export default {
	loadLayout: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: LayoutAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${payload}`
			},
			true
		);
		if (res && res.Data && res.Success) {
			//Cập nhật lại layout Store
			context.commit('updateLayoutInfos', { Id: payload, Data: res.Data });
			return res.Data;
		}
		return res;
	},
	saveLayout: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: LayoutAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/save`,
			data: payload
		});

		if (res && res.Data && res.Success) {
			//Cập nhật lại layout Store
			context.commit('updateLayoutInfos', { Id: payload.LayoutId, Data: res.Data });
		}
		return res;
	},
	resetLayout: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: LayoutAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/reset`,
			params: payload
		});

		if (res && res.Success && res.Data) {
			context.commit('resetLayoutInfo', payload.layoutId);
		}
		return res;
	}
};
